

export function HappyAnniversaryCarousel(props: any) {
    if (!props?.isAnniDay) return null; // Ensure it renders only when it's an anniversary

    return (
        <div className="card border-0 mb-0 pb-0">

            <img
                src={props.web_url}
                className="w-100 img-fluid desktopImage"
                alt="Anniversary Wishes"
            />

            <img
                src={props.mobile_url}
                className="w-100 img-fluid mobileImage"
                alt="Anniversary Wishes"
            />
            <div className="card-img-overlay text-start">
                <div className="row mb-4">
                    <div className="col-md-12 pt-0 pt-md-3 ms-2 ms-md-5">
                        {props?.profileData?.oracle?.employee?.first_name ? (
                            <>
                                <h2 className="text-start mb-2 mb-md-4">
                                    Happy Anniversary {props?.displayName}!!!
                                </h2>
                                <p className="text-start mb-1">
                                    The TTEC family wishes you Happy Anniversary! We want to
                                    congratulate you on your {props?.expYears}-year anniversary!
                                </p>
                                <p className="text-start mb-1">
                                    Your hard work and dedication are vital to TTEC's success.
                                </p>
                                <p className="text-start">TTEC Family</p>
                            </>
                        ) : null} {/* Instead of empty string, return null */}
                    </div>
                </div>
            </div>
        </div>
    );
}
